import { createSlice } from '@reduxjs/toolkit';

import { generateUUID } from '../../utils/util';

export const initialState = {
  notices: [],
  spinners: [],
};

export const SystemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    addSystemNotice: (state, action) => {
      const { type, message } = action.payload;

      if (message.toLowerCase().includes('request aborted')) return;

      state.notices.push({ id: generateUUID(), type, message });
    },
    removeSystemNotice: (state, action) => {
      const updatedNotices = state.notices.filter((notice) => notice.id !== action.payload);
      state.notices = updatedNotices;
    },
    addSpinner: (state, action) => {
      state.spinners.push(action.payload);
    },
    removeSpinner: (state, action) => {
      state.spinners = state.spinners.filter((spinner) => spinner !== action.payload);
    },
    resetSystemSlice: () => initialState,
  },
});

export const { addSystemNotice, removeSystemNotice, addSpinner, removeSpinner, resetSystemSlice } = SystemSlice.actions;

export default SystemSlice.reducer;
